/**
 * Copyright IBM Corp. 2022, 2026
 */

import s from './skeleton.module.css'
import classNames from 'classnames'

export const SKELETON_COLOR = ['faint', 'strong'] as const
export type SkeletonColor = (typeof SKELETON_COLOR)[number]

export interface SkeletonProps extends React.PropsWithChildren {
	animate?: boolean
	border?: boolean
	className?: string
	color?: SkeletonColor
	style?: React.CSSProperties
}

export const Skeleton = ({
	animate = true,
	border = true,
	children,
	className,
	color = 'strong',
	style,
}: SkeletonProps) => {
	return (
		<div
			className={classNames(
				s.skeleton,
				s[color],
				border && s.border,
				animate && s.animate,
				className,
			)}
			style={style}
			aria-hidden="true"
		>
			{children}
		</div>
	)
}

Skeleton.displayName = 'Skeleton'
